import React from 'react';
import { ReactComponent as ThickDownArrow } from '../../assets/images/icons/thickDownArrow.svg';

export default function ThickDownArrowIcon(props) {
  return (
    <ThickDownArrow className={`icon ${props.className}`} />
  );
}
